import generateFrontPath from "@raiden/library/libraries/utils/generateFrontPath";
import dayjs from "dayjs";
import { LANDING_FALLBACK, LANDING_SETTINGS } from "../constants/Landing";

/**
 * @typedef {Object} Props
 * @property {boolean} isDesktop
 */
/**
 * Get landing image path
 * @param {Props} props
 * @returns {string}
 */
export function getLandingImage({ isDesktop }) {
  const todayDate = dayjs();
  let filePath = LANDING_FALLBACK;

  for (const landing of LANDING_SETTINGS) {
    if (
      todayDate.month() + 1 >= landing.start_month &&
      todayDate.month() + 1 <= landing.end_month &&
      todayDate.date() >= landing.start_day &&
      todayDate.date() <= landing.end_day
    ) {
      if (isDesktop) {
        filePath = landing.path_video;
      } else {
        filePath = landing.path;
      }
      break;
    }
  }

  return generateFrontPath({
    id: "@front.internal-assets",
    parameters: { filePath },
    includeBasePath: true,
  });
}
